import React from 'react'
import {
  Box,
  Button,
  Typography
} from '@mui/material'

const ApplicationCard = ({
  post,
  representativesCount = 3,
  appliedCount = 8,
  onApply = () => {}
}) => {
  const postNames = {
    ae: 'Assistant Engineer (AE)',
    aee: 'Assistant Executive Engineer (AEE)',
    ee: 'Executive Engineer (EE)'
  }
  return (
    <Box sx={{
      border: '1px solid',
      borderRadius: '12px',
      padding: '16px',
      borderColor: 'divider',
      minWidth: '31.5%'
    }}
    >
      <Typography variant='med_16_500' sx={{ mb: 5 }}>{postNames[post] ?? 'Error loading post...'}</Typography>
      <Box sx={{
        border: '1px solid',
        borderColor: 'secondary.main',
        p: 1,
        borderRadius: '6px',
        backgroundColor: 'secondary.light',
        mt: 1.5,
        mb: 2.5
      }}
      >
        <Typography variant='med_14_500' sx={{ color: 'grey1' }}>{representativesCount} Representatives</Typography>
      </Box>
      <Box sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between'
      }}
      >
        <Typography variant='med_14_500' color='grey1'>{appliedCount} Applied</Typography>

        <Button variant='contained' onClick={onApply}>Apply</Button>
      </Box>
    </Box>
  )
}

export default ApplicationCard
